import React, { useReducer, PropsWithChildren } from "react";
import { TableContextProviderProps, TableContextState } from "models/propTypes/simpleTableProps";
import { TableReducer } from "./reducer";
import { ContextConstants } from "utils/constants";
import { WintUtilsWebApi } from "wint-api-client/dist/types";

export const TableContext = React.createContext<TableContextState>({
  tableKey: "",
  filter: {} as WintUtilsWebApi.Filter,
  setFilter: <T extends WintUtilsWebApi.Filter>(filter: T) => {},
});

const TableContextProvider: React.FC<PropsWithChildren<TableContextProviderProps>> = (props) => {
  const [state, dispatch] = useReducer(TableReducer, {
    tableKey: props.tableKey,
    filter: props.filter ?? ({} as WintUtilsWebApi.Filter),
    setFilter: <T extends WintUtilsWebApi.Filter>(filter: T) => {},
  });

  const setFilter = <T extends WintUtilsWebApi.Filter>(filter: T) => {
    dispatch({ type: ContextConstants.TableActions.SET_TABLE_FILTER, payload: filter });
  };

  return (
    <TableContext.Provider
      value={{
        ...state,
        setFilter,
      }}
    >
      {props.children}
    </TableContext.Provider>
  );
};

export default TableContextProvider;
